var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F5F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 70,
    height: 12,
    rx: 3,
    fill: "#D3D4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 33H75C76.6569 33 78 34.3431 78 36V64C78 65.6569 76.6569 67 75 67H70V33Z",
    fill: "#1E78E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 29C62 28.4477 62.4477 28 63 28H67C68.6569 28 70 29.3431 70 31V69C70 70.6569 68.6569 72 67 72H63C62.4477 72 62 71.5523 62 71V29Z",
    fill: "#4FA5F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C24 34.3431 25.3431 33 27 33H32V67H27C25.3431 67 24 65.6569 24 64V36Z",
    fill: "#1E78E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31C32 29.3431 33.3431 28 35 28H39C39.5523 28 40 28.4477 40 29V71C40 71.5523 39.5523 72 39 72H35C33.3431 72 32 70.6569 32 69V31Z",
    fill: "#4FA5F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_1300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 28,
    width: 70,
    height: 44
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 28C62.4477 28 62 28.4477 62 29V44H40V29C40 28.4477 39.5523 28 39 28H35C33.3431 28 32 29.3431 32 31V33H27C25.3431 33 24 34.3431 24 36V44H19C17.3431 44 16 45.3431 16 47V53C16 54.6569 17.3431 56 19 56H24V64C24 65.6569 25.3431 67 27 67H32V69C32 70.6569 33.3431 72 35 72H39C39.5523 72 40 71.5523 40 71V56H62V71C62 71.5523 62.4477 72 63 72H67C68.6569 72 70 70.6569 70 69V67H75C76.6569 67 78 65.6569 78 64V56H83C84.6569 56 86 54.6569 86 53V47C86 45.3431 84.6569 44 83 44H78V36C78 34.3431 76.6569 33 75 33H70V31C70 29.3431 68.6569 28 67 28H63Z",
    fill: "#61B1EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_1300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5312,
    y: 50,
    width: 71,
    height: 22,
    fill: "#122771",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOt);
export default __webpack_public_path__ + "static/media/OT.99bf0453fde517b4e62a6cda3d8d7e23.svg";
export { ForwardRef as ReactComponent };